import React, { Component } from "react";
import "./index.css";

class InfoBlock extends Component {
  shouldComponentUpdate() {
    return this.props.dynamic || false;
  }

  render() {
    const { title, children, centered } = this.props;
    const titleClassName = centered ? `title has-text-centered` : `title`;
    return (
      <div className="info-block transitioned-fade-in">
        <div className="container">
          {title && <h1 className={titleClassName}>{title}</h1>}
          {children}
        </div>
      </div>
    );
  }
}

export default InfoBlock;



// WEBPACK FOOTER //
// ./src/presentational/InfoBlock/index.js